import React from 'react';
import {Input} from 'antd'

const IvTable = ({data = [], dates, scenarioIndex, onChangeIV, todayOpenDiffDays}) => {
  
  return <table>
    {
      dates.map((d, i)=> {
        return <tr key={i}>
          <td>{d || ''}</td>
          <td>
            <Input value={data[i] || ''}
                     name="name"
                     disabled={i < todayOpenDiffDays}
                     onChange={(e) => onChangeIV(e, i, scenarioIndex)}
                     placeholder="IV"/>
          </td>
        </tr>
      })
    }
  </table>
}

export default IvTable;



// WEBPACK FOOTER //
// ./src/components/view-trades/IvTable.js